export { default as Cb } from "./payment-cb.png";
export { default as AmericanExpress } from "./payment-american-express.png";
export { default as VirementBancaire } from "./payment-virement-bancaire.png";
export { default as BankTranfer } from "./payment-bank-transfer.png";
export { default as Mastercard } from "./payment-mastercard.png";
export { default as Paypal } from "./payment-paypal.png";
export { default as Visa } from "./payment-visa.png";
export { default as Free } from "./payment-img-free.jpg";
